"use client";

import { useEffect } from "react";
const SV_CSS = "@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500&family=Cormorant+Garamond:ital,wght@1,400&display=swap');\n.sv-wrap{--bg:#0a0a0a;--sf:#111;--bd:rgba(255,255,255,.07);--wh:#f0ede8;--mu:rgba(240,237,232,.42);--go:#c8a96e;--re:#c0392b;--ez:cubic-bezier(.22,1,.36,1);background:var(--bg);color:var(--wh);font-family:'DM Sans',sans-serif;font-weight:300}\n.sv-hero{position:relative;padding:110px 40px 72px;text-align:center;overflow:hidden;border-bottom:1px solid var(--bd)}\n.sv-hero::before{content:'';position:absolute;inset:0;background-image:linear-gradient(rgba(255,255,255,.02) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.02) 1px,transparent 1px);background-size:60px 60px;pointer-events:none}\n.sv-hero::after{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 70% 60% at 50% 100%,rgba(200,169,110,.06),transparent 70%);pointer-events:none}\n.sv-stag{display:inline-flex;align-items:center;gap:10px;font-size:.63rem;letter-spacing:.25em;text-transform:uppercase;color:var(--go);margin-bottom:16px;position:relative;z-index:1}\n.sv-stag::before,.sv-stag::after{content:'';display:block;width:24px;height:1px;background:var(--go)}\n.sv-htitle{font-family:'Bebas Neue',sans-serif;font-size:clamp(4rem,10vw,9rem);line-height:.85;letter-spacing:-.02em;margin-bottom:18px;position:relative;z-index:1}\n.sv-htitle em{font-family:'Cormorant Garamond',serif;font-style:italic;color:var(--go);font-size:.85em}\n.sv-hsub{font-size:.95rem;color:var(--mu);max-width:500px;margin:0 auto;position:relative;z-index:1;line-height:1.75}\n.sv-list{padding:80px 0;border-top:1px solid var(--bd)}\n.sv-row{display:grid;grid-template-columns:72px 1fr auto;align-items:start;gap:32px;padding:48px 48px;border-bottom:1px solid var(--bd);position:relative;overflow:hidden;text-decoration:none;color:inherit;transition:background .3s}\n.sv-row::before{content:'';position:absolute;inset:0;background:var(--sf);transform:scaleX(0);transform-origin:left;transition:transform .5s var(--ez);z-index:0}\n.sv-row:hover::before{transform:scaleX(1)}\n.sv-row>*{position:relative;z-index:1}\n.sv-num{font-family:'Bebas Neue',sans-serif;font-size:2.2rem;color:var(--go);line-height:1;padding-top:4px}\n.sv-body{flex:1}\n.sv-title{font-family:'Bebas Neue',sans-serif;font-size:clamp(2rem,4vw,4rem);letter-spacing:-.01em;line-height:1;margin-bottom:12px;transition:transform .4s var(--ez)}\n.sv-row:hover .sv-title{transform:translateX(12px)}\n.sv-desc{font-size:.88rem;color:var(--mu);line-height:1.75;max-width:560px}\n.sv-tags{display:flex;gap:8px;flex-wrap:wrap;margin-top:16px}\n.sv-tag{padding:4px 12px;font-size:.6rem;letter-spacing:.18em;text-transform:uppercase;border:1px solid var(--bd);color:var(--mu)}\n.sv-arrow{width:48px;height:48px;border:1px solid var(--bd);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:6px;transition:background .3s,border-color .3s,transform .35s var(--ez)}\n.sv-row:hover .sv-arrow{background:var(--go);border-color:var(--go);transform:rotate(45deg)}\n.sv-cta{padding:120px 48px;text-align:center;position:relative;overflow:hidden;border-top:1px solid var(--bd);background:var(--sf)}\n.sv-cta::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 55% 45% at 50% 100%,rgba(200,169,110,.08),transparent 70%);pointer-events:none}\n.sv-cta-title{font-family:'Bebas Neue',sans-serif;font-size:clamp(3.5rem,9vw,8rem);line-height:.85;letter-spacing:-.02em;position:relative;z-index:1;margin-bottom:28px}\n.sv-cta-title em{display:block;font-family:'Cormorant Garamond',serif;font-style:italic;color:var(--go);font-size:.7em}\n.sv-cta-sub{font-size:.92rem;color:var(--mu);max-width:360px;margin:0 auto 44px;line-height:1.75;position:relative;z-index:1}\n.sv-btn{display:inline-flex;align-items:center;gap:12px;padding:14px 36px;background:var(--wh);color:var(--bg);text-decoration:none;font-size:.72rem;font-weight:500;letter-spacing:.18em;text-transform:uppercase;transition:background .2s,gap .3s var(--ez);position:relative;z-index:1}\n.sv-btn:hover{background:var(--go);gap:18px}\n.sv-rv{opacity:0;transform:translateY(28px);transition:opacity .75s var(--ez),transform .75s var(--ez)}\n.sv-rv.on{opacity:1;transform:translateY(0)}\n@media(max-width:900px){.sv-row{grid-template-columns:48px 1fr auto;gap:20px;padding:36px 28px}}\n@media(max-width:600px){.sv-row{grid-template-columns:36px 1fr;gap:14px;padding:28px 20px}.sv-arrow{display:none}.sv-cta,.sv-hero{padding-left:20px;padding-right:20px}}";
export default function NosServices() {
  useEffect(() => {
    if (!document.getElementById("sv-style")) {
      const s = document.createElement("style");
      s.id = "sv-style";
      s.textContent = SV_CSS;
      document.head.appendChild(s);
    }
    const obs = new IntersectionObserver(entries => entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add("on");
        obs.unobserve(e.target);
      }
    }), {
      threshold: 0.08,
      rootMargin: "0px 0px -40px 0px"
    });
    document.querySelectorAll(".sv-rv").forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);
  return <div className="sv-wrap">
      {/* Hero */}
      <div className="sv-hero">
        <p className="sv-stag">JokerStudio</p>
        <h1 className="sv-htitle">Nos <em>services</em></h1>
        <p className="sv-hsub">De la vidéographie à la photographie, nous couvrons chaque moment avec une qualité cinématographique à Montréal.</p>
      </div>

      {/* Liste services */}
      <div className="sv-list">
        <a key={0} href="/contact/" className="sv-row sv-rv" style={{
        transitionDelay: "0s"
      }}>
          <span className="sv-num">01</span>
          <div className="sv-body">
            <h2 className="sv-title">Vidéographie événements</h2>
            <p className="sv-desc">Mariages, conférences, spectacles – nous capturons chaque moment avec créativité et professionnalisme.</p>
            <div className="sv-tags">
              <span className="sv-tag">Mariage</span>
              <span className="sv-tag">Corporatif</span>
              <span className="sv-tag">Spectacle</span>
            </div>
          </div>
          <span className="sv-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M8 3l5 5-5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
        </a>

        <a key={1} href="/contact/" className="sv-row sv-rv" style={{
        transitionDelay: "0.1s"
      }}>
          <span className="sv-num">02</span>
          <div className="sv-body">
            <h2 className="sv-title">Photographie professionnelle</h2>
            <p className="sv-desc">Portraits, corporatif, produits – des images qui racontent votre histoire avec authenticité.</p>
            <div className="sv-tags">
              <span className="sv-tag">Portrait</span>
              <span className="sv-tag">Corporatif</span>
              <span className="sv-tag">Produit</span>
            </div>
          </div>
          <span className="sv-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M8 3l5 5-5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
        </a>

        <a key={2} href="/contact/" className="sv-row sv-rv" style={{
        transitionDelay: "0.2s"
      }}>
          <span className="sv-num">03</span>
          <div className="sv-body">
            <h2 className="sv-title">Promotion image de marque</h2>
            <p className="sv-desc">Vidéos publicitaires et contenus pour réseaux sociaux qui amplifient votre présence en ligne.</p>
            <div className="sv-tags">
              <span className="sv-tag">Réseaux sociaux</span>
              <span className="sv-tag">Publicité</span>
              <span className="sv-tag">Branding</span>
            </div>
          </div>
          <span className="sv-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M8 3l5 5-5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
        </a>

        <a key={3} href="/contact/" className="sv-row sv-rv" style={{
        transitionDelay: "0.30000000000000004s"
      }}>
          <span className="sv-num">04</span>
          <div className="sv-body">
            <h2 className="sv-title">Services DJ + photographie</h2>
            <p className="sv-desc">Animation musicale et captation photo pour des événements inoubliables et dynamiques.</p>
            <div className="sv-tags">
              <span className="sv-tag">DJ</span>
              <span className="sv-tag">Événement</span>
              <span className="sv-tag">Animation</span>
            </div>
          </div>
          <span className="sv-arrow" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M8 3l5 5-5 5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
        </a>
      </div>

      {/* CTA */}
      <section className="sv-cta">
        <h2 className="sv-cta-title sv-rv">Votre projet<br /><em>commence ici</em></h2>
        <p className="sv-cta-sub sv-rv" style={{
        transitionDelay: ".1s"
      }}>
          Vous avez une idée ? Parlons-en — chaque histoire mérite d’être racontée avec style.
        </p>
        <div className="sv-rv" style={{
        transitionDelay: ".2s"
      }}>
          <a href="/contact/" className="sv-btn">
            Nous contacter
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 6.5h9M6.5 2l4.5 4.5L6.5 11" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </a>
        </div>
      </section>
    </div>;
}